import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=ad2aba48&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2aba48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad2aba48')) {
      api.createRecord('ad2aba48', component.options)
    } else {
      api.reload('ad2aba48', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=ad2aba48&scoped=true&", function () {
      api.rerender('ad2aba48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8WsyQkOL06k6v/JS/comp/Accordion.vue"
export default component.exports